import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import ArticleIcon from '@mui/icons-material/Article';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useQuery } from '../hooks/useQuery';
import CircularProgress from '@mui/material/CircularProgress';
import Moment from 'moment';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import 'moment/locale/pt-br';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export const ListarFaqPage = (props) => {
  const { listarFaqs, deletarFaqs } = useQuery();
  const [faqs, setFaqs] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const theme = useTheme();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    height: '90%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const listar = async () => {
    setLoading(true);

    const result = await listarFaqs();

    if (result && result.data) {
      setFaqs(result.data.data);
    }

    setLoading(false);
  };

  React.useEffect(() => {
    listar();
  }, []);

  return (
    <Box
      mt={8}
      sx={{ width: '100%', minHeight: '100vh' }}
      backgroundColor="#FAFCFF"
    >
      <AppBar position="static" color={'primary'} style={{ padding: 10 }}>
        <Grid container>
          <Grid
            item
            xs={12.5}
            alignItems="center"
            display="flex"
            justifyContent="space-between"
          >
            <Grid item display="flex" alignItems="center">
              <ArticleIcon
                sx={{
                  fontSize: 40,
                  display: { xs: 'none', md: 'flex' },
                }}
              />
              <span style={{ color: 'white', fontSize: 20 }}>Faq</span>
            </Grid>
          </Grid>
        </Grid>
      </AppBar>
      <Grid container spacing={1} paddingY="2rem" paddingX="1rem">
        <Grid item sm={12}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <CircularProgress style={{ marginTop: 60 }} />
            </Box>
          ) : (
            <div>
              {faqs &&
                faqs.map((faq, index) => {
                  return (
                    <Accordion
                      key={index}
                      expanded={expanded === `panel${index}`}
                      onChange={handleChange(`panel${index}`)}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel${index}bh-content`}
                        id={`panel${index}bh-header`}
                      >
                        <Typography>{faq && faq.pergunta}</Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Typography>{faq && faq.resposta}</Typography>
                      </AccordionDetails>
                    </Accordion>
                  );
                })}
            </div>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
